"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconMembershipFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 22 16",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M22,0 L22,16 L0,16 L0,0 L22,0 Z M12.8333333,2.66666667 L12.8333333,3.55555556 L20.1666667,3.55555556 L20.1666667,2.66666667 L12.8333333,2.66666667 M12.8333333,4.44444444 L12.8333333,5.33333333 L19.7083333,5.33333333 L20.1666667,5.33333333 L20.1666667,4.44444444 L12.8333333,4.44444444 M12.8333333,6.22222222 L12.8333333,7.11111111 L19.25,7.11111111 L19.25,6.22222222 L12.8333333,6.22222222 M7.33333333,9.69777778 C5.5,9.69777778 1.83333333,10.6666667 1.83333333,12.4444444 L1.83333333,13.3333333 L12.8333333,13.3333333 L12.8333333,12.4444444 C12.8333333,10.6666667 9.16666667,9.69777778 7.33333333,9.69777778 M7.33333333,2.66666667 C5.81455027,2.66666667 4.58333333,3.860574 4.58333333,5.33333333 C4.58333333,6.80609267 5.81455027,8 7.33333333,8 C8.8521164,8 10.0833333,6.80609267 10.0833333,5.33333333 C10.0833333,3.860574 8.8521164,2.66666667 7.33333333,2.66666667 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconMembershipFilled')(IconMembershipFilled);